module.exports = __webpack_public_path__ + "img/yth.bff01324.jpg";